<kendo-menu
  #menu
  [openOnClick]="{ toggle: 'leave' }"
  (open)="onMenuOpen($event)"
  (close)="onClose($event)"
  (select)="onMenuSelect($event)"
  [items]="menuItems"
>
</kendo-menu>

<ng-template let-item="item" #tools>
  <fa-icon [icon]="['fas', 'screwdriver-wrench']"></fa-icon>
</ng-template>

<ng-template #tableFontSize>
  <div class="p-4">
    <app-font-size-manager
      [fontSize]="fontSize"
      (fontSizeChange)="changeFontSize($event)"
    ></app-font-size-manager>
  </div>
</ng-template>

<ng-template #tableColumns>
  <div class="p-4">
    <app-column-manager
      #tableColumns
      [columns]="columns"
      [view]="view"
    ></app-column-manager>
  </div>
</ng-template>

<kendo-dialog
  *ngIf="uploadDialogVisible && currentImportUrl"
  (close)="uploadDialogVisible = false"
  [title]="'Upload ' + view + ' file'"
>
  <app-importer
    [importUrl]="currentImportUrl"
    (success)="onUploadComplete($event)"
  ></app-importer>
</kendo-dialog>

<kendo-dialog
  *ngIf="configurationDialogVisible"
  (close)="configurationDialogVisible = false"
  [width]="600"
  title="Delivery Settings"
>
  <ng-container *ngTemplateOutlet="configurationTemplate"></ng-container>
</kendo-dialog>
